module.exports = __webpack_public_path__ + "img/58.e28b1c0.e28b1c05.png";